export const UPSERT_BRAND_MODEL = `
mutation upsertBrandModel($key: String!) {
  upsertBrandModel(key: $key){
    __typename
    ... on SyncBoolean{
      status
    }
    ... on ResultError{
      status_code
      message
    }
  }
}
`;
